import { dayjs } from '../../lib'

/**
 * 判断对象
 * @param data 当前的data
 */
export function isObject(data: any) {
  return typeof data === 'object' && data !== null;
}

/**
 * 检查 value 是否是 null 或者 undefined。
 * @param value 检查的 value
 * @returns boolean
 */
export function isNil(value: any): value is null | undefined {
  return value === undefined || value === null;
}

/**
 * 判断复杂数据类型
 * @param value 需要判断类型的值
 * @returns 数据类型
 */
export function getTag(value: any): string {
  const toString = Object.prototype.toString;
  return toString.call(value);
}

/**
 * 判断数据是否为空
 * @param value 被判断的数据
 * @returns 是否为空
 */
export function isEmpty(value: any): boolean {
  if (value == null) return true;
  const tag = getTag(value);
  if (Array.isArray(value) || typeof value === "string"
    || tag === "[object Arguments]" || (value.length && typeof value.length === "number")
  ) return !value.length; // 判断字符串或类数组

  if (tag === '[object Map]' || tag === '[object Set]') { // 判断Map或Set实例
    return !value.size;
  }

  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return false;
}

/**
 * 判断数据是否为数字
 * @param value 被判断的数据
 * @returns 是否为数字
 */
export function isNumber(v: any) {
  return isNaN(Number(v)) ? false : true;
}


/**
 * @description: 判断两参数是否相等
 * @param {any} data
 * @param {any} preData
 * @return {*}
 */
export function isEqual(data: any, preData: any) {
  // 两者不均为对象
  if (!isObject(data) || !isObject(preData)) {
    return data === preData;
  }
  // 两者为同一对象或者数组
  if (data === preData) return true;

  if (Object.prototype.toString.call(data) !== Object.prototype.toString.call(preData)) return false;

  if (Object.prototype.toString.call(data) === "[object Array]") {
    if (data.length !== preData.length) return;
  }

  // 2023.08.29 针对日期类型单独调整
  if (Object.prototype.toString.call(data) === '[object Date]') {
    const d1 = dayjs(data)
    const d2 = dayjs(preData)
    return d1.isValid() && d2.isValid() && +dayjs(data) === +dayjs(preData)
  }

  // 判断对象/数组 keys 长度
  const dataKeys = Object.keys(data);
  const preDataKeys = Object.keys(preData);
  if (dataKeys.length !== preDataKeys.length) return false;

  // 对象/数组 keys长度一致，比较内容
  for (let key in data) {
    const res = isEqual(data[key], preData[key]);
    if (!res) return false;
  }
  return true;
}